export function setToseck(toseck) {
    localStorage.setItem('toseck', toseck)
}
export function getToseck() {
    return localStorage.getItem('toseck')
}

// export function getToseck() {
//     return localStorage.getItem('toseck');
// }


export function delToseck() {
    localStorage.removeItem('toseck')
}